module.exports = __webpack_public_path__ + "static/img/two.3cd3921.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/4/two.png
// module id = 7aMq
// module chunks = 1